import BaseCrudService from './baseCrud.service'

class NotificationService extends BaseCrudService {
  constructor () {
    super('notification', {
      id: false,
      read_at: null
    })
  }
}

export default NotificationService
